import React, { useState } from 'react'
import Select from 'react-select'
import Creatable from 'react-select/creatable'
import { useSelector } from 'react-redux'

import { useToggle, usePet } from '../../modules'

import Confirm from '../reusable/confirm'
import Modal from "../reusable/modal"
import NewWard from './newWard'

const MovePatient = ({ toggle, visible, admission, onPerform }) => {
    const [wards, setWards] = useState([])
    const [ward, setWard] = useState()
    const [beds, setBeds] = useState([])
    const [bed, setBed] = useState()
    const [wardName, setWardName] = useState()
    
    const [newWard, toggleNewWard] = useToggle()

    const [, getWards] = usePet('wards', { active: true, limit: 50 }, { notify: true, callback: ({ data }) => setWards(data.wards) })

    const { user } = useSelector(state => state.application)

    const onComplete = (_, notif, ops) => {
        notif('Patient has been admitted', ops('success'))
        setTimeout(toggle, 300)
        onPerform()
    }

    const [{ loading }, movePatient] = usePet('movePatient', {
        id: admission?._id,
        bed: bed?._id
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Recording admission...' } })
    
    const [, getWard] = usePet('ward', { id: ward?._id }, { notify: true, callback: ({ data }) => setBeds(data.beds), manual: true })

    const createNewWard = name => {
        setWardName(name)
        toggleNewWard()
    }

    const onCreateWard = data => {
        setWard({ label: data.name, value: data._id, ...data })
        getWards()
    }

    const selectWard = ward => {
        setWard(ward)
        setBed(null)
        getWard()
    }

    const move = () => Confirm({
        title: 'Move patient?',
        message: 'This patient will vacate the currently occupied bed and occupy the specified one',
        okText: 'Move patient',
        onOk: movePatient
    })

    return (
        <Modal
            w={ 400 }
            title="Move Patient"
            toggle={toggle}
            visible={visible}>
            {
                newWard &&
                <NewWard
                    visible={ newWard }
                    name={ wardName }
                    onPerform={ onCreateWard }
                    toggle={ toggleNewWard } />
            }
            <div className="flex flex-wrap mb-6">
                <div className="w-full my-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Ward
                    </label>
                    {
                        user?.issuperuser ?
                            <Creatable
                                value={ward}
                                onChange={selectWard}
                                onCreateOption={createNewWard}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={(wards ?? [])?.map(ward => ({ label: ward.name, value: ward._id, ...ward }))}
                                placeholder="Select Or Add New Ward" />
                            :
                            <Select
                                value={ward}
                                onChange={selectWard}
                                styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                                options={(wards ?? [])?.map(ward => ({ label: ward.name, value: ward._id, ...ward }))}
                                placeholder="Select Ward" />
                    }
                </div>
                <div className="w-full my-3">
                    <label className="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" htmlFor="grid-name">
                        Bed
                    </label>
                    {
                        user?.issuperuser ?
                            <Creatable
                                value={bed}
                                onChange={setBed}
                                isDisabled={!ward}
                                onCreateOption={createNewWard}
                                styles={{ 
                                    input: styles => ({ ...styles, minWidth: '10em' }),
                                    option: (styles, { isDisabled }) => ({ 
                                        ...styles, 
                                        backgroundColor: isDisabled ? undefined : styles.backgroundColor,
                                        color: isDisabled ? 'gray' : styles.color,
                                        cursor: isDisabled ? 'not-allowed' : 'default' 
                                    })
                                }}
                                options={(beds ?? [])?.map(bed => ({ label: `${bed.name}${ bed.occupied ? ' (Occupied)' : ''}`, value: bed._id, isDisabled: bed.occupied, ...bed }))}
                                placeholder="Select Or Add New Bed"
                                 />
                            :
                            <Select
                                value={bed}
                                onChange={setBed}
                                isDisabled={!ward}
                                styles={{ 
                                    input: styles => ({ ...styles, minWidth: '10em' }),
                                    option: (styles, { isDisabled }) => ({ 
                                        ...styles, 
                                        backgroundColor: isDisabled ? undefined : styles.backgroundColor,
                                        color: isDisabled ? 'gray' : styles.color,
                                        cursor: isDisabled ? 'not-allowed' : 'default' 
                                    })
                                }}
                                options={(beds ?? [])?.map(bed => ({ label: `${bed.name}${ bed.occupied ? ' (Occupied)' : ''}`, value: bed._id, isDisabled: bed.occupied, ...bed }))}
                                placeholder="Select Bed" />
                    }
                </div>
            </div>
            <div className="flex justify-end">
                <button onClick={ move } className="text-white hisani-btn-green-light font-medium rounded-lg text-sm px-5 py-2.5 text-center">Proceed</button>
            </div>
        </Modal>
    )
}

export default MovePatient